import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { AvatarDob, PublicDob } from '../UiKit/AvatarPanel';
import { Background } from '../UiKit/Background';
import { theme } from '../UiKit/Colors';
import { DesignToggles } from '../UiKit/DesignToggles';
import { Preview } from '../UiKit/Preview';
import { Search } from '../UiKit/Search';
import { getPrsDes, resolveDesign } from '../utilsDesign';
import { Definition } from './Definition';
import { Astro } from './Astro';
import { Jyotish } from './Jyotish';
import { UncertainSourceSelect } from './UncertainSourceSelect';
import { WithVersion } from '../UiKit/VersionToggler';

export const Full = React.memo((props) => {


  const {
    id,
    user,
    avatar,
    children,
    loading,
    numbers,
    planets,
    hoverable,
    advanced,
    publ,
    penta,
    hints,
    noSettings,
    noBodyView,
    noHeading,
    noSearch,
    addControls,
    noHints,
    noDob = false,
    addClassName = 'main',
    noAstro = false,
    noJyotish = false,
    underlayDesign,
    omitUnderlayGates,
    omitUnderlayCenters,
    questionPlanets,
  } = { ...props };

  // console.log('user = ', user);

  const bodyContainer = useRef(null);

  const design = resolveDesign(avatar.design);

  const [hintsInner, setHintsInner] = useState(hints);
  const [numbersInner, setNumbers] = useState(numbers);
  const [planetsInner, setPlanets] = useState(planets);
  const [advancedInner, setAdvanced] = useState(advanced);
  const [arrows, setArrows] = useState(true);
  const [prs, setPrs] = useState({});
  const [des, setDes] = useState({});
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ = context.$;
  const $ui = context.$ui;
  const $type = context.$type;
  const $profile = context.$profile;
  const $line = context.$line;

  // const almostVisiblePrs = '#efefef';
  // const almostVisibleDes = '#ffe4e5';
  const almostVisiblePrs = 'blue';
  const almostVisibleDes = 'orange';

  // const [profileId, setProfileId] = useState(`${design['profile'][0]}${design['profile'][1]}`);
  // console.log('design = ', design);
  const profileId = design.id && design.id !== 'dummy' ? `${design['profile'][0]}${design['profile'][1]}` : '';
  const linePrs = design.id && design.id !== 'dummy' ? `${design['profile'][0]}` : '';
  const lineDes = design.id && design.id !== 'dummy' ? `${design['profile'][1]}` : '';

  useEffect(() => {
    setDesignInner(design)
    setPrs({})
    setDes({})
  }, [design, design.id])


  const setTheme = () => {
    context.setState.setColorMode(context.state.colorMode === 'colorsClassic' ? 'colorsModern' : 'colorsClassic')
  }

  const [designInner, setDesignInner] = useState(design)


  useEffect(() => {


    if (design.id !== designInner.id) {
      setDesignInner(design)
    }
    if (prs.linePersonality) {
      setDesignInner(getPrsDes(design, 'des'));
    }
    if (des.lineDesign) {
      setDesignInner(getPrsDes(design, 'prs'));
    }
    if (!des.lineDesign && !prs.linePersonality) {
      setDesignInner(design)
      // setProfileId(`${design['profile'][0]}${design['profile'][1]}`);
    }

  }, [prs, des, design.id])


  const hintsTheme = {
    designColor: '#ff00001b',
    personalityColor: '#00000011',
    // openColor: '#FFF',
    // definedColor: '#010101',
    // authorityColor: 'black',
    lineOpen: '#ffffff0',
    line0: '#d6d6d6',
    line0comp: 'transparent',
  }


  const [colorTheme, setColorTheme] = useState(hintsTheme)

  useEffect(() => {
    if (hintsInner) {
      setColorTheme({
        ...theme,
        ...hintsTheme
      })
    } else {
      setColorTheme(theme)
    }
  }, [hintsInner])

  const navigate = useNavigate();
  const location = useLocation();
  const handleCloseInfoPop = () => {
    document.body.classList.remove('noscroll');
    context.setState.setHighlighted()
    context.setState.setSearch([])

    const removeStudySegments = (pathname) => {
      const segments = pathname.split('/study')
      return segments.length > 1 ? segments[0] : null
    };
    const currentPath = location.pathname;
    const newPath = removeStudySegments(currentPath);
    if (newPath) navigate(newPath);
  };



  const a0 = useRef(null);
  const a1 = useRef(null);
  const a2 = useRef(null);
  const a3 = useRef(null);
  const a4 = useRef(null);
  const a5 = useRef(null);
  const a6 = useRef(null);
  const a7 = useRef(null);


  useEffect(() => {
    // Add scroll event listener
    // window.addEventListener('scroll', handleScroll);

    // Set initial styles for animation
    const animateElements = () => {
      const elements = [
        a0,
        a1,
        a2,
        a3,
        a4,
        a5,
        a6,
        a7
      ];
      elements.forEach((ref, index) => {
        if (ref.current) {
          ref.current.style.opacity = '0';
          // ref.current.style.transform = `translateY(-${20 / index}px)scale3d(${1 / index},${1 / index},${1 / index})`;
          ref.current.style.transform = `translateY(-${10 * (index / 4)}px)`;
          ref.current.style.transition = `opacity ${50 + (30 * index)}ms ease, transform ${50 + (50 * index)}ms ease`; // Add transition
          ref.current.style.transitionTimingFunction = `cubic-bezier(.023, .393, .25, 1), ease`
        }
      });

      // Trigger animation after a staggered delay
      elements.forEach((ref, index) => {
        setTimeout(() => {
          if (ref.current) {
            ref.current.style.opacity = '1';
            ref.current.style.transform = `translateY(0)scale3d(1,1,1)`;
          }
        }, index * 50); // Stagger by 100ms for each element
      });
    };

    animateElements(); // Call the animation function

    // return () => {
    //   window.removeEventListener('scroll', handleScroll);
    // };
  }, []);

  // console.log('avatar = ', avatar);



  const handleAstroClick = (what = 'astro') => {
    let newPath = location.pathname.split('/study')[0];
    newPath = newPath.slice(-1) === '/' ? newPath + `study/${what}` : newPath + `/study/${what}`
    const queryParams = location.search ? location.search : '';
    navigate(`${newPath}${queryParams}`);
  };




  return (
    <>






      <div className="x_edu_content x_edu_content--full"
      // onClick={() => handleCloseInfoPop()}
      >

        <div className="x0_topline"
          ref={a1}
          style={{ opacity: context.state.calcShown ? 0 : 1 }}
        >


          {!noDob && !noSettings && <UncertainSourceSelect variant="dropdown" />}

          {!noDob && <>
            {!avatar.unsaved && <AvatarDob
              avatar={avatar}
              user={user}
              penta={penta}
            />}

            {avatar.unsaved && <PublicDob
              avatar={avatar}
            />}
          </>}

          {(!noSettings || !noSearch) && <div className="_f _fm">
            {design.id !== 'dummy' && <>


              {!noSettings && <DesignToggles
                theme={context.state.colorMode === 'colorsClassic'}
                setTheme={setTheme}
                numbers={numbersInner}
                planets={planetsInner}
                hints={hintsInner}
                arrows={arrows}
                advanced={underlayDesign ? false : advancedInner}
                prs={!prs.linePersonality}
                des={!des.lineDesign}
                setNumbers={() => setNumbers((prev) => !prev)}
                setPlanets={() => {
                  if (planetsInner) {
                    setPlanets(false)
                    setAdvanced(false)
                  }
                  if (!planetsInner) {
                    setPlanets(true)
                  }
                }}

                setArrows={() => setArrows((prev) => !prev)}
                setHints={() => setHintsInner((prev) => !prev)}
                setAdvanced={() => {
                  if (!planetsInner && !advancedInner) setPlanets(true)
                  setAdvanced((prev) => !prev)
                }}
                setPrs={() => setPrs((prev) => !prev.linePersonality ? { linePersonality: almostVisiblePrs } : {})}
                setDes={() => setDes((prev) => !prev.lineDesign ? { lineDesign: almostVisibleDes } : {})}
                editAvailable={avatar['my'] || publ ? true : false}
              />}

              {!noSearch && <Search design={design} />}


            </>}
          </div>}

          {addControls}



        </div>



        <div
          className="x_edu_100"
          onClick={() => setHintsInner(false)}
        >



          {Boolean(avatar.dob)
            && <WithVersion>
              <div className="x_edu_astronumero mobile_vh_yesf">
                {context.state.astroShown
                  && Boolean(avatar.astro) && !noAstro
                  && <Astro
                    avatar={avatar}
                    handleClick={handleAstroClick}
                  />}
                {context.state.jyotishShown
                  && !noJyotish
                  && <Jyotish
                    avatar={avatar}
                    handleClick={handleAstroClick}
                  />}
              </div>
            </WithVersion>}



          {(!noHints && design.id !== 'dummy') && <div className={`x_edu_help0 ${hintsInner ? 'active' : ''} mobile_v_no`}
            onClick={(e) => {
              e.stopPropagation()
              setHintsInner(prev => !prev)
            }}
          >
            {/* <div className={`x_body_view ${hintsInner ? 'active' : ''}`} onClick={() => setHintsInner(prev => !prev)}>
              <Icon>contact_support</Icon>
              {$ui('edu_help_bodygraph')}
            </div> */}
            <div className="x_help_ico">🤷‍♂️</div>
            {/* <Switch
              active={hintsInner}
              handle={() => setHintsInner(prev => !prev)}
              label={$ui('edu_help_bodygraph')}
            /> */}
          </div>}


          <div
            ref={a2}
            className="x_body_content x_body_content--fullpro"
          // style={{ border: '1px solid red' }}
          // ref={bodyContainer}
          >

            {designInner.type !== 'dummy' && <div
              className={`x_bodygraph_base ${underlayDesign ? 'x_bodygraph_base--underlay' : ''}`}
              // style={{ minWidth: '30em', minHeight: '35em' }}
              ref={bodyContainer}
            >
              {underlayDesign && (
                <div className="x_uncertain_potential" aria-hidden>
                  <Preview
                    body
                    hoverable={false}
                    parentContainer={bodyContainer}
                    planets={false}
                    arrowsB={false}
                    arrowsP={false}
                    numbers={false}
                    aura={false}
                    openTransparent
                    omitGates={omitUnderlayGates}
                    omitCenters={omitUnderlayCenters}
                    key={underlayDesign.id}
                    design={underlayDesign}
                    colorTheme={colorTheme}
                    addClassName={`${addClassName} uncertain-potential`}
                    blur
                  />
                </div>
              )}
              <Preview
                mode3d={context.state.mode3d}
                appear3d={context.state.mode3d}
                body={hintsInner ? false : true}
                style={{
                  opacity: hints ? 0 : 1
                }}
                hints={hintsInner}
                hoverable={hoverable}
                // interactive={true}
                parentContainer={bodyContainer}
                // width={500}
                // height={800}
                // planetsDes={(planetsInner && !des.lineDesign && !prs.linePersonality) ? true : prs.linePersonality}
                // planetsPrs={(planetsInner && !des.lineDesign && !prs.linePersonality) ? true : des.lineDesign}
                planets={planetsInner}
                arrowsB={(arrows && !des.lineDesign && !prs.linePersonality) ? true : prs.linePersonality}
                arrowsP={(arrows && !des.lineDesign && !prs.linePersonality) ? true : des.lineDesign}
                numbers={numbersInner}
                aura={false}
                openTransparent={Boolean(underlayDesign)}
                // design={{
                //   ...design,
                //   active_chakras: designInner.active_chakras
                // }}
                design={designInner}
                preloader={(!design && avatar.dob) || loading}
                // colorTheme={{ ...prs, ...des }}
                colorTheme={colorTheme}
                highlightedGate={context.state.search}
                highlighted={context.state.highlighted}
                advanced={underlayDesign ? false : advancedInner}
                questionPlanets={questionPlanets}
                addClassName={addClassName}
              />
            </div>}


          </div>




          {/* <Definition design={designInner} /> */}




          {design.id !== 'dummy' && !noHeading && <div className="x_edu_1st ">
            <div className="x_edu_content_h x_edu_content_h--2"
              ref={a3}
            >
              {
                <>
                  {/* {drawType(design['type'], 'auth', design['auth'])}  */}
                  {/* {drawType(design['type'], 'full', design['auth'])} */}
                  {$type(designInner['type'], 'title')}
                </>}
            </div>

            {(!prs['linePersonality'] && !des['lineDesign']) && <div className="x_edu_content_h x_edu_content_h--3"
              ref={a4}
            >
              {$profile(profileId, 'profile')}  "{$profile(profileId, 'title')}"
            </div>}


            {(prs['linePersonality'] && !des['lineDesign']) && <div className="x_edu_content_h x_edu_content_h--3"
              ref={a5}
            >
              {$line(lineDes, 'id')}  "{$line(lineDes, 'title')}"
            </div>}

            {(!prs['linePersonality'] && des['lineDesign']) && <div className="x_edu_content_h x_edu_content_h--3"
              ref={a6}
            >
              {$line(linePrs, 'id')}  "{$line(linePrs, 'title')}"
            </div>}




            {/* <div className="x_edu_content_title_auth">{drawType(design['type'], 'auth', design['auth'])} Inner Authority</div> */}
          </div>}


          {design.id !== 'dummy' && !noBodyView && <div className="x_body_view0"
            ref={a7}
          >


            <div className={(prs['linePersonality'] && !des['lineDesign']) ? "x_body_view active" : 'x_body_view '}
              onClick={() => {
                setDes({})
                setPrs({ 'linePersonality': almostVisiblePrs })
              }}
            >
              <div className="x_type-xs"><div className={`x_typexs ${(design.des || '').toLowerCase()}`} /></div>
              <div>{$ui('body_des')}</div>
            </div>

            <div className={(!prs['linePersonality'] && !des['lineDesign']) ? "x_body_view active" : 'x_body_view '}
              onClick={() => {
                setPrs({})
                setDes({})
              }}
            >
              <div className="x_type-xs"><div className={`x_typexs ${(design.type || '').toLowerCase()}`} /></div>
              <div>{$ui('body_fullbody')}</div>
            </div>

            <div className={(!prs['linePersonality'] && des['lineDesign']) ? "x_body_view active" : 'x_body_view '}
              onClick={() => {
                setPrs({})
                setDes({ 'lineDesign': almostVisibleDes })
              }}
            >

              <div className="x_type-xs"><div className={`x_typexs ${(design.prs || '').toLowerCase()}`} /></div>

              <div>{$ui('body_prs')}</div>
            </div>



          </div>}


        </div>

        <div
          className="x_edu_bg0 inactive"
        >
          <Background 
            design={designInner} 
            className='x_design_bg_full inact' 
            style={{ height: '100%', zIndex: -1 }} 
          />
        </div>

      </div>

      {/* <div className="x_edu_bg0">
        <Background design={designInner} style={{ height: '100%', zIndex: -1 }} />
      </div> */}


    </>
  )
})




